import {Search} from 'lucide-react';

import {Input} from '@/components/ui/input';
import {cn} from '@/utils/ui';

export type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  description?: string;
  placeholder?: string;
};

const SearchInput = ({
  description,
  placeholder,
  value,
  onChange,
}: SearchInputProps) => {
  return (
    <div className="flex w-full flex-col gap-1 md:max-w-[360px]">
      <div className="relative">
        <Search className="absolute top-[50%] left-3 translate-y-[-50%] text-neutral" />
        <Input
          value={value}
          onChange={evt => {
            onChange(evt.target.value);
          }}
          className={cn(
            'rounded-full! border-neutral-200! pl-11 placeholder-neutral!'
          )}
          placeholder={placeholder || 'Search'}
        />
      </div>
      {description && <p className="text-xs text-gray-700">{description}</p>}
    </div>
  );
};

export default SearchInput;
